<tui-root [class.fullscreen]="isFullscreen()">
  @if (showNavbar()) {
    <app-navbar />
  }
  <main class="app-main" [class.fullscreen]="isFullscreen()">
    <router-outlet />
  </main>
  @if (showNavbar()) {
    <app-footer />
  }
  @if (showNavbar() && isLoggedIn()) {
    <app-help-button />
  }
</tui-root>
